<template>
  <div>
    <div class="input-item">
    	<label for="server_name" class="input-label">服务项目名称</label>
		  <el-input v-model="form.server_name" id="server_name" placeholder="请输入服务项目名称" class="item"></el-input>
		</div>
		<div class="input-item">
			<label class="input-label">服务项目类型</label>
			<el-select v-model="form.type" placeholder="请选择服务项目类型" class="item">
		    <el-option
		      v-for="item in service_type_list"
		      :key="item.type"
		      :label="item.label"
		      :value="item.type">
		    </el-option>
		  </el-select>
		</div>
		<div class="input-item">
    	<label for="server_price" class="input-label">服务项目金额</label>
		  <el-input v-model="form.server_price" id="server_price" placeholder="请输入服务项目金额" class="item"></el-input>
		</div>
		<div class="input-item">
    	<label for="sort" class="input-label">排序</label>
		  <el-input type="number" v-model="form.sort" id="sort" placeholder="请输入排列序号（越大越靠前）" class="item"></el-input>
		</div>
		<div class="input-item">
    	<label for="message" class="input-label">提醒文字</label>
		  <el-input v-model="form.message" id="message" placeholder="请输入用户上传图片时需要备注上传图片的内容" class="item"></el-input>
		</div>
		<div>服务项目图片（35*45）</div>
		<div>{{server_icon.length}}/1</div>
		<imageUpload v-model="server_icon" :limit="1"/>
		<div class="case-title">案例图片（正常尺寸通用）</div>
		<div>{{form.case_img.length}}/6</div>
		<imageUpload v-model="form.case_img" :limit="6"/>
		<div class="btn-wrap">
			<el-button type="primary" class="confirmBtn" @click="confirmClick">确认</el-button>
			<el-button @click="cancelClick">取消</el-button>
		</div>
  </div>
</template>

<script>
import imageUpload from '@/components/ImageUpload';
import { newService, serviceDetail, editService } from '@/api/service';

export default {
  name: 'projectoperate',
  data() {
  	return {
  		form: {
  			server_name: '',
  			type: '',
  			sort: '',
  			message: '',
  			server_price: '',
  			case_img: [],
  			server_icon: '',
  		},
  	  service_type_list: [
        { type: '1', label:'淘宝项目'},
        { type: '2', label:'非淘宝项目'}
  	  ],
  	  server_icon: [],
  	  operateType: 'add',
  	}
  },
  components: {
  	imageUpload,
  },
  mounted() {
     let uuid = this.$route.query.uuid;
     if (uuid) {
     	 this.operateType = 'edit';
       this.getServiceDetail(uuid);
     }
     console.log(uuid, 'uuid')
  },
  methods: {
  	cancelClick() {
  		this.$router.go(-1);
  	},
  	async confirmClick() {
  		if (!this.form.server_name) {
  			this.$message('服务项目名称不能为空');
  			return;
  		}
  		if (!this.form.type) {
  			this.$message('请选择服务项目类型');
  			return;
  		}
  		if (!this.form.server_price) {
  			this.$message('服务项目金额不能为空');
  			return;
  		}
  		if (!this.form.sort) {
  			this.$message('排序号不能为空');
  			return;
  		}
  		if (this.form.sort < 1 || this.form.sort > 99 || this.form.sort%1 !== 0) {
  			this.$message('排序号只能为1至99范围的整数');
  			return
  		}
  		if (!this.form.message) {
  			this.$message('提醒文字不能为空');
  			return;
  		}
  		if (!this.server_icon.length) {
  			this.$message('服务项目图片不能为空');
  			return;
  		}
  		if (!this.form.case_img.length) {
  			this.$message('案例图片不能为空');
  			return;
  		}
  		this.form.server_icon = this.server_icon.join();
	  	if (this.operateType === 'add') {
	  		const { status } = await newService(this.form);
	  		if (status === 200) this.$router.go(-1);
	  	} else if (this.operateType === 'edit') {
	  		const { status } = await editService(this.form);
	  		if (status === 200) this.$router.go(-1);
	  	}
  	},
  	async getServiceDetail(uuid) {
       const { data, status } = await serviceDetail(uuid);
       if (status !== 200) return
       	this.form = data;
       this.server_icon = [data.server_icon];
       	console.log(data, 'detail')
  	}
  }
}
</script>

<style lang="less" scoped>
.input-item {
	margin-bottom: 25px;
	.input-label {
		display: block;
		margin-bottom: 10px;
	}
	.item {
		width: 400px;
	}
}
.case-title {
	padding-top: 30px;
}
.btn-wrap {
	text-align: center;
	padding-top: 30px;
	padding-bottom: 30px;
	.confirmBtn {
		margin-right: 50px;
	}
}
</style>
